import moment from 'moment'
import FirebaseCares from './cares'
import Care from '@/types/Care'
import Child from '@/types/Child'

interface SummaryChartRow {
  timestamp: moment.Moment
  ageStr: string,
  value: Number
}

export default class extends FirebaseCares {
  getSample(): SummaryChartRow[] {
    const time = moment()
    return Array.from({length: 11}, (_, i): SummaryChartRow => ({
      timestamp: time.clone().add(i, 'days'),
      ageStr: `1歳11ヶ月`,
      value: Math.random() * 2 + i + 10,
    }))
  }

  getAgeStr(birthday: moment.Moment, timestamp: moment.Moment): string {
    const y = timestamp.diff(birthday, 'years')
    const m = timestamp.diff(birthday, 'months') - (y * 12)
    return `${y}歳${m}ヶ月`
  }

  async getSummaryBase(child: Child, careType: string, dataParam: string): Promise<SummaryChartRow[]> {
    const cares = await this.getCares(child.id, { careType })
    return cares
      .filter(o => o.careData[dataParam])
      .map((care: Care): SummaryChartRow => ({
        timestamp: care.caredAt,
        ageStr: this.getAgeStr(child.birthday, care.caredAt),
        value: Number(care.careData[dataParam]) || 0,
      }))
  }

  getSummaryHeight(child: Child) {
    return this.getSummaryBase(child, 'height', 'height')
  }

  getSummaryWeight(child: Child) {
    return this.getSummaryBase(child, 'weight', 'weight')
  }

  getSummaryTemperature(child: Child) {
    return this.getSummaryBase(child, 'temperature', 'temperature')
  }
}
